import { Link } from "react-router-dom";
import MainLayout from "@/components/layout/MainLayout";
import Seo from "@/components/base/Seo";

const values = [
  { icon: "ri-focus-3-line", title: "分类清晰", desc: "以全题材分类大全为核心，让每一部作品都有清晰的归属，读者按兴趣直达。" },
  { icon: "ri-line-chart-line", title: "榜单可信", desc: "人气排行与热门榜单基于真实阅读数据，客观呈现当下最受欢迎的作品。" },
  { icon: "ri-heart-line", title: "内容用心", desc: "从新作推荐到完结专区，精选有质量、有温度的漫画内容，认真对待每一次推荐。" },
  { icon: "ri-leaf-line", title: "免费友好", desc: "设立免费专区，让更多好作品触手可及，降低每一位读者的阅读门槛。" },
];

const principles = [
  "内容多元：覆盖恋爱、热血、悬疑、治愈等全题材，尊重不同读者的口味差异。",
  "推荐客观：排行榜依据真实热度与评分，不夸大、不误导，让你放心选择。",
  "持续更新：新作推荐与榜单实时刷新，第一时间呈现最新上线的好作品。",
  "体验至上：分类清晰、页面干净、操作简单，把时间留给阅读本身。",
];

export default function About() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: "关于歪歪漫画网",
      url: "https://panelpal.github.io/about",
      inLanguage: "zh-CN",
      description: "歪歪漫画网是专注于漫画分类大全与内容推荐的平台，覆盖恋爱、热血、悬疑、治愈等全题材。",
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "歪歪漫画网",
      url: "https://panelpal.github.io/",
      description: "漫画分类大全与内容推荐平台",
    },
  ];

  return (
    <MainLayout>
      <Seo
        title="关于歪歪漫画网 - 品牌介绍与内容理念"
        description="了解歪歪漫画网：我们以漫画分类大全与内容推荐为核心，覆盖恋爱、热血、悬疑、治愈等全题材，坚持清晰分类、可信榜单与免费友好的内容理念。"
        keywords="歪歪漫画网,关于我们,品牌介绍,内容理念,漫画平台"
        canonical="/about"
        jsonLd={jsonLd}
      />

      <section className="border-b border-background-200/70 bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
          <nav className="flex items-center gap-1.5 text-sm text-foreground-500" aria-label="面包屑">
            <Link to="/" className="hover:text-primary-600">首页</Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-foreground-800">关于我们</span>
          </nav>
          <div className="mt-6 max-w-3xl">
            <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-team-line" /> 关于歪歪漫画网
            </span>
            <h1 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">让每一部好漫画，都能被热爱它的人看见</h1>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              歪歪漫画网是一个以漫画分类大全与内容推荐为核心的内容平台。我们相信，好的作品不该被埋没。无论你喜欢甜甜的恋爱、燃到爆的热血，还是细思极恐的悬疑与抚慰人心的治愈，都能在这里找到属于自己的那一部。
            </p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          <div>
            <h2 className="font-heading text-2xl text-foreground-950">我们是谁</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              歪歪漫画网致力于打造一个「分类清晰、榜单可信、免费友好」的漫画阅读推荐平台。我们围绕全题材分类大全组织内容，配合实时更新的人气排行与热门榜单，并持续精选新作、完结与免费作品，帮助读者快速定位、安心选择、畅快阅读。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              从一份分类到一张榜单，从一部新作到一个专区，我们坚持把选择权交给读者，同时用更清晰的结构和更真实的数据，替大家省下找作品的时间。
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="rounded-lg border border-background-200/70 bg-background-50 p-5 text-center">
              <p className="font-heading text-4xl text-primary-600">10+</p>
              <p className="mt-1 text-sm text-foreground-600">全题材分类</p>
            </div>
            <div className="rounded-lg border border-background-200/70 bg-background-50 p-5 text-center">
              <p className="font-heading text-4xl text-accent-600">3000+</p>
              <p className="mt-1 text-sm text-foreground-600">人气漫画作品</p>
            </div>
            <div className="rounded-lg border border-background-200/70 bg-background-50 p-5 text-center">
              <p className="font-heading text-4xl text-secondary-600">1000+</p>
              <p className="mt-1 text-sm text-foreground-600">免费漫画</p>
            </div>
            <div className="rounded-lg border border-background-200/70 bg-background-50 p-5 text-center">
              <p className="font-heading text-4xl text-primary-600">实时</p>
              <p className="mt-1 text-sm text-foreground-600">榜单更新</p>
            </div>
          </div>
        </div>
      </section>

      <section className="border-y border-background-200/70 bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
          <h2 className="font-heading text-2xl text-foreground-950">我们的发展理念</h2>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {values.map((v) => (
              <div key={v.title} className="rounded-lg border border-background-200/70 bg-background-50 p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-xl text-background-50">
                  <i className={v.icon} />
                </span>
                <h3 className="mt-4 text-base font-semibold text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          <div>
            <h2 className="font-heading text-2xl text-foreground-950">内容原则</h2>
            <p className="mt-3 text-sm text-foreground-600">我们如何挑选和呈现内容，始终遵循以下原则：</p>
            <ul className="mt-5 space-y-3">
              {principles.map((p) => (
                <li key={p} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-700">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-check-line text-sm" />
                  </span>
                  {p}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h2 className="font-heading text-2xl text-foreground-950">联系我们</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              无论是建议、反馈还是想推荐你喜爱的作品，都欢迎随时与我们联系。我们会认真阅读每一条留言，让歪歪漫画网变得更好。
            </p>
            <div className="mt-5 space-y-3 rounded-lg border border-background-200/70 bg-background-50 p-5">
              <div className="flex items-center gap-3 text-sm text-foreground-700">
                <i className="ri-mail-line text-lg text-primary-600" /> contact@waiwaimanga.com
              </div>
              <div className="flex items-center gap-3 text-sm text-foreground-700">
                <i className="ri-global-line text-lg text-primary-600" /> waiwaimanga.com
              </div>
              <div className="flex items-center gap-3 text-sm text-foreground-700">
                <i className="ri-time-line text-lg text-primary-600" /> 工作日 9:00 - 18:00 在线
              </div>
            </div>
          </div>
        </div>
      </section>
    </MainLayout>
  );
}